import { ActionsData, ApplicationDataState, VehicleCategory, VehicleData } from './application.model';

export const mockedActionsData: ActionsData = {
  cckNumber: '21851957',
  actions: []
};

export const mockedVehicle: VehicleData = {
  category: VehicleCategory.CAR,
  registrationNumber: 'AA123BB',
  vinNumber: '1234567',
  used: false,
  import: false
};

export const initialValue: ApplicationDataState = {
  actionsData: mockedActionsData,
  vehicleData: mockedVehicle
};

export const productionInitialValue = {};
